import { Component, OnDestroy, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import {
    DidDataRetrievalService,
    t_DataPoint,
} from 'src/app/services/apiHandler/did-data-retrieval/did-data-retrieval.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
    selector: 'app-multiple-did-data-table',
    templateUrl: './multiple-did-data-table.component.html',
    styleUrls: ['./multiple-did-data-table.component.scss'],
})
export class MultipleDidDataTableComponent implements OnInit, AfterViewInit, OnDestroy {
    public displayedColumns: string[] = ['ecu_id', 'data_id', 'timestamp', 'value'];//, 'more'];
    public dataSet: MatTableDataSource<t_DataPoint> = new MatTableDataSource<t_DataPoint>();
    public querySubscription: Subscription = new Subscription();

    constructor(private apiDataConnection: DidDataRetrievalService, public router: Router) {}

    @ViewChild(MatSort) sort: MatSort = new MatSort();

    /* Setup OnInit - AfterViewInit - OnDestroy */

    ngOnInit(): void {
        this.apiDataConnection.initService();
        this.getAllDidsValues();
        this.querySubscription = this.apiDataConnection.queryLiveObs.subscribe((queryLiveStatus) => {
            if (queryLiveStatus == true) {
                this.getAllDidsValues();
            }
        });
    }

    ngAfterViewInit() {
        this.dataSet.sort = this.sort;
    }

    ngOnDestroy(): void {
        this.querySubscription.unsubscribe();
    }

    /* Functions */

    public getAllDidsValues(): void {
        this.apiDataConnection.getAllDidsValues().subscribe((response) => {
            if (response.body != null) {
                this.dataSet.data = response.body;
            }
        });
    }

}

interface DidValue {
    did: number;
    timestamp: Date;
    value: number[];
}
